<template>
  <div>
    <div class="d-flex align-items-center mb-4">
      <h2>{{ $t('perfil.tutor') }}</h2>
      <span class="barra-tit flex-fill"></span>
    </div>

    <div class="box-meus-tutores">
        <meu-tutores :aluno="aluno" />
    </div>

  </div>
</template>

<script>
import MeuTutores from '@/modules/Perfil/components/meus-tutores'

export default {
  name: 'MeuTutoresPerfil',
  components: { MeuTutores },
  props: {
    aluno: Object
  }
}
</script>

<style scoped>

</style>
